"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.discountTimeSchema = exports.discountTimeInitialized = void 0;
const joi_1 = __importDefault(require("joi"));
const joiMessages_1 = require("../data/joiMessages");
const validations_1 = require("../data/validations");
exports.discountTimeInitialized = {
    name: "",
    description: "",
    discountText: "",
    from: "",
    to: "",
    monday: false,
    tuesday: false,
    wednesday: false,
    thursday: false,
    friday: false,
    saturday: false,
    sunday: false,
    time: {},
    times: [],
};
exports.discountTimeSchema = joi_1.default.object({
    name: joi_1.default.string().required().messages({
        ...(0, joiMessages_1.joiStringMessage)({ name: 'Name', isRequired: true }),
    }),
    description: joi_1.default.string().optional().allow('').messages({
        ...(0, joiMessages_1.joiStringMessage)({ name: 'Description' }),
    }),
    discountText: joi_1.default.string().optional().allow('').messages({
        ...(0, joiMessages_1.joiStringMessage)({ name: 'Discount text' }),
    }),
    time: joi_1.default.any(),
    times: joi_1.default.array(),
    monday: joi_1.default.boolean(),
    tuesday: joi_1.default.boolean(),
    wednesday: joi_1.default.boolean(),
    thursday: joi_1.default.boolean(),
    friday: joi_1.default.boolean(),
    saturday: joi_1.default.boolean(),
    sunday: joi_1.default.boolean(),
    from: joi_1.default.string().optional().pattern(validations_1.militaryTimeAndEmptyRegex).allow('').min(0).max(5).messages({
        ...(0, joiMessages_1.joiStringMessage)({ name: 'From', patternText: 'has to be on the form "hh:mm" such as 13:05' }),
    }),
    to: joi_1.default.string().optional().pattern(validations_1.militaryTimeAndEmptyRegex).allow('').min(0).max(5).messages({
        ...(0, joiMessages_1.joiStringMessage)({ name: 'To', patternText: 'has to be on the form "hh:mm" such as 13:05' }),
    }),
});
